<h1 class="fw-u2 mwx-5">Locating your membership</h1>

<main class="fld-col flg-5 ai-ctr">
  <h3 class="ct-primary-rev fw-u3">Success!</h3>

  <p *ngIf="vehicles?.length === 0">
    We found your account but it doesn't look like you have any vehicles. Would
    you like to link anyway?
  </p>

  <p *ngIf="vehicles?.length > 1">
    Please confirm your vehicles' plates
  </p>

  <p *ngIf="vehicles?.length === 1">
    Please confirm your vehicle's plate
  </p>
  <div class="fld-col flg-5">
    <mat-card *ngFor="let vehicle of vehicles" class="vehicle-row">
      <mat-card-content>
        <span
          *ngIf="vehicle.hasMembership"
          class="membership membership-badge ta-c"
        >
          {{ !vehicle.hasMembership ? ''  : (washLevelName | titlecase )?? 'Member' }}
        </span>
        <div class="vehicle-image ta-c">
          <evox-vehicle-image [vehicle]="vehicle"></evox-vehicle-image>
        </div>
        <span *ngIf="vehicle.make" class="make-model fw-u3">
          {{ vehicle | map: toMakeModel }}
        </span>
        <span class="lp-vin nowrap fls-1-1">
          {{ vehicle | displayVehiclePlate }}
        </span>
      </mat-card-content>
    </mat-card>
  </div>
  <footer class="fld-row flg-5 jc-ctr vw-p100">
    <button
      myqq-button
      aria-label="Cancel"
      class="raised"
      (click)="cancel()"
      fill="clear"
      (keydown.enter)="$event.preventDefault()"
      (keyup.enter)="cancel()"
    >
      Cancel
    </button>

    <button
      myqq-button
      aria-label="Confirm"
      class="raised"
      color="primary"
      (keydown.enter)="$event.preventDefault()"
      (keyup.enter)="confirm()"
      (click)="confirm()"
    >
      Confirm
    </button>
  </footer>
</main>
